export const SIGNATURE = '@SIGNATURE';
export const EVENT_TRANSFER = '@EVENT_TRANSFER';
export const CONNECT_WALLET = '@CONNECT_WALLET';
export const RESET_STATE = '@RESET_STATE_WALLET';
export const ERC20_APPROVED = '@ERC20_APPROVED';
